import React from 'react'
import { Screen } from '~common/screen'
import { StyledScreen } from '~common/screen'
import Form from '~/components/form'
import ym from 'react-yandex-metrika'
import gtag from '~/helpers/gtag'

const DontLoseClients = () => {
  return (
    <Screen
      title={<span><StyledScreen.GreenText>Не теряйте</StyledScreen.GreenText> клиентов</span>}
      bottomLine
      className='dont-lose-clients'
    >
      <div className='dont-lose-clients__container'>
        <p className='dont-lose-clients__text'>Налаживайте коммуникацию в переписке безопасным для бизнеса способом</p>
        <p className='dont-lose-clients__text'>Протестируйте чаты 7 дней бесплатно и убедитесь в их удобстве и эффективности</p>
        <div className='dont-lose-clients__form'>
          <Form
            formType='service'
            text='Протестировать'
            pageName='Чаты'
            onSubmit={() => {
              ym('reachGoal', 'lead_chats', 631388)
              gtag('event', 'submit_number_chats', {'event_category': 'lead_chats', 'event_action': 'click'})
            }}
          />
        </div>
      </div>
    </Screen>
  )
}

export default DontLoseClients